import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconClipboard2"><Path fillRule="evenodd" clipRule="evenodd" d="M17 2H7V4H3V22H21V4H17V2ZM15 4H9V6H15V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard2;
